import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BackButton, TableData } from "components";
import { errorAlert } from "helpers/alerts";
import { getAllPDSProductsService, getPDSProductsService } from "services/admin/productService";
import { Box, Grid } from "@mui/material";
import { setBagPDSProductService } from "services/client/bagService";
import { setPDSProducts } from "redux/slices/admin/productSlice";
import { setPDSProducts as setBagPDSProducts } from "redux/slices/client/bagSlice";
import { setLoading } from "redux/slices/uiSlice";
import { validatePermission } from "helpers/authentication";
import { sortArrayBy } from "helpers/util";

const BagPDSProductScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentCommerce } = useSelector((store) => store.commerces);
  const currentBag = currentCommerce.bags.find(bag => bag.type === 'PDS');
  const {
    justProducts,
    currentPDSSegment,
    pdsProducts: bagPDSProducts,
  } = useSelector((store) => store.bags);
  const {
    pdsProducts
  } = useSelector((state) => state.products);


  useEffect(() => {
    if (justProducts)
      getAllPDSProductsService()
        .then((data) => dispatch(setPDSProducts(data)))
        .catch(error => errorAlert(error))
    else
      getPDSProductsService(currentPDSSegment.id)
        .then((data) => dispatch(setPDSProducts(data)))
        .catch(error => errorAlert(error))
    // eslint-disable-next-line
  }, []);

  const handlerCheck = async (row, state) => {
    dispatch(setLoading(true));
    setBagPDSProductService(currentBag.id, row.idSegment.id, row.id, {
      state: !state
    }).then((response) => {
      dispatch(setBagPDSProducts(response));
    }).catch(error => errorAlert(error))
      .finally(() => dispatch(setLoading(false)));
  };

  const handlerSetCommission = async (commission, row) => {
    dispatch(setLoading(true));
    setBagPDSProductService(currentBag.id, row.idSegment.id, row.id, {
      commission
    }).then((response) => {
      dispatch(setBagPDSProducts(response));
    }).catch(error => errorAlert(error))
      .finally(() => dispatch(setLoading(false)));
  };

  return (
    <>
      <Box mt={2} />
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <BackButton click={() => navigate(-1)} />
        </div>
        <div className="container-title">
          <div className="commerce">Servicios</div>
          {!justProducts && <div className="bag">{currentPDSSegment.name} </div>}
        </div>
        <div>
        </div>
      </Grid>
      <TableData
        dataRows={sortArrayBy(pdsProducts, a => a.name).map((item) => {
          const service = bagPDSProducts?.find(({ idProduct }) => idProduct.id === item.id);
          return {
            ...item,
            service
          };
        })}
        dataTitle={[
          "Logo",
          "Nombre",
          validatePermission("comercios", "comisiones", ["ver"]) && "Comision del Canal",
          "Asignado"
        ].filter(Boolean)}
        formatter={({ fd, name, service }) => [
          { type: "img", value: `/v3/file/${fd}/` },
          name,
          validatePermission("comercios", "comisiones", ["ver"]) && {
            name: "commission",
            type: "input",
            value: service?.commission || 0,
            disabled: !service?.state,
            onBlur: handlerSetCommission
          },
          { name: "state", type: "boolean", value: service?.state },
        ].filter(Boolean)}
        onChecked={handlerCheck}
      />
    </>
  );
};

export default BagPDSProductScreen;
